import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";
import { getRequest } from '../../../../../api/ApiService';
import { Loader } from 'react-loaders';
import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 80%;
`;

const Label = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  flex: 1;
  text-align: center;
  margin-bottom: 10px;
`;

const Line = styled.div`
  width: 100%;
  height: 35px;
  background: #52c5cd;
  position: relative;
`;

const InnerLine = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 35px;
  background: #00274c;
`;

const RedDot = styled.div`
  position: absolute;
  top: 12.5px;

  ${p => p.left && `
    left: ${p.left};
  `}

  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: #ff5252;
  text-align: center;

  span {
    font-family: 'Mukta Vaani';
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    color: rgba(0, 27, 59, 0.94);

    position: relative;
    top: 22px;

    ${p => p.cw && `
      left: ${p.cw}px;
    `}
  }
`;

const XAxisLabel = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  color: rgba(0, 27, 59, 0.94);
  position: absolute;
  bottom: -28px;

  ${p => p.left && `
    left: ${p.left};
  `}
`;

class RevenuesStep3 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      prices: [],
    };
  }

  componentDidMount() {
    const { activeRound } = this.props;

    getRequest(
      `${process.env.REACT_APP_API_URL}team/price_forecasts/?round_number=${activeRound}`
    )
      .then(res => {
        this.setState({
          loaded: true,
          prices: res.body.map(i => Number(i.price)).filter(i => i > 0),
        })
      })
      .catch(err => {});
  }

  convertPriceToPosition(price) {
    if (price >= 12) {
      return `${(Math.floor(price) - 12) / 0.46 + 50}%`;
    }

    return `${(Math.floor(price) - 2) * 5}%`;
  }

  convertPriceToCW(price) {
    return (`${price}`.replace(/[^0-9]/, '').length + 1) / 2 * -5;
  }

  render() {
    const {
      loaded,
      prices,
    } = this.state;

    return loaded ? (
      <BannerLayout
        section="FEEDBACK"
        subSection="REVENUES"
        hideAlert={true}
        subTitle="Pricing Your Products"
        paragraph1={(
          <Fragment>
            Let's explore your pricing. Here's the price range of what customers are willing to pay
            in relation to the prices that you set for your product(s).
          </Fragment>
        )}
        paragraph2={(
          <Fragment>
            Given what customers' are willing to pay and other Research data, could you have set your
            product's selling prices higher to meet your revenue target?
          </Fragment>
        )}
        visual={(
          <Fragment>
            <Row>
              <Label>Mobile</Label>
              <Label>Auto</Label>
            </Row>
            <Row>
              <Line>
                <InnerLine />
                {prices.map((price, index) => (
                  <RedDot key={`red-dot-${index}`} left={this.convertPriceToPosition(price)} cw={this.convertPriceToCW(price)}>
                    <span>${price}</span>
                  </RedDot>
                ))}

                <XAxisLabel left="-10px">$2</XAxisLabel>
                <XAxisLabel left="calc(50% - 15px)">$12</XAxisLabel>
                <XAxisLabel left="calc(100% - 20px)">$35</XAxisLabel>
              </Line>
            </Row>
          </Fragment>
        )}
        visualProps={{
          flexCenter: true,
          flexDirection: 'column',
          noPadding: true,
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default RevenuesStep3;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/revenues/step3.js